import { useEffect } from 'react';
import { useMainPageStore } from '~/pages/MainPage/model/useMainPageStore';
import { LoadingSpinner } from '~/shared/ui/LoadingSpinner/LoadingSpinner';
import { PageWrapper } from '~/shared/ui/PageWrapper/PageWrapper';

export const BootScreen = () => {
  const { actions } = useMainPageStore();
  const { setIsOpen } = actions;

  useEffect(() => {
    setTimeout(() => setIsOpen('none'), 3000);
  }, []);

  return (
    <PageWrapper className="flex flex-col justify-between">
      <img src="/images/AppStore-icon.png" alt="" className={'m-auto w-5'} />
      <LoadingSpinner className="[&_path]:fill-[#02CC6B]" />
    </PageWrapper>
  );
};
